<template>
  <form @submit.prevent class="login-form-box login-pagegap otp-page">
    <div class="logo-img">
      <v-img
        max-height="60"
        max-width="230"
        :src="logo_image"
        :lazy-src="logo_image"
      >

      </v-img>
    </div>
    <h4 class="welcome-text">Verify Mobile OTP</h4>
    <v-row>
      <v-col>
        <v-text-field 
        class=""
          v-model="confirmationCode"
          :error-messages="confirmationCodeErrors"
          label="We have sent OTP on your registered Mobile No."
          placeholder="Enter OTP"
          required
          @input="$v.confirmationCode.$touch()"
          @blur="$v.confirmationCode.$touch()"
          @keypress="updateValue($event,confirmationCode)"
        ></v-text-field>
      </v-col>
    </v-row>
    <span v-bind:class="{'error-messagebox-login': isAddClassServerError}" id="server_side_error">{{serverError}}</span>
    <v-row>
      <v-col>
        <v-btn
          class="blue-btn btn"
          @click="submit"
          :disabled="!isFormValid" :error-messages="buttonErrorMessage"
        >
          Verify OTP
        </v-btn>
    </v-col>
    </v-row>
    <v-row>
      <v-col>
          <v-btn @click="backtologin" class="back-link">
            Back to login
          </v-btn>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <v-btn :disabled="disabledButton" @click="resendOtp" class="back-link">
             Resend OTP
          </v-btn>
      </v-col>
    </v-row>
  </form>
</template>

<script>
    import { validationMixin } from 'vuelidate'
    import { required, email, minLength, sameAs, isAlphanumeric, maxLength } from "vuelidate/lib/validators";
    import { Auth } from 'aws-amplify';
    import JwtService from ".././common/jwt.service";
    import { VERIFY_MOBILE_OTP, VERIFY_EMAIL_OTP, USER_SIGNIN } from "../../store/actions.type";
    import { isEmpty } from 'lodash';

  export default {
    mixins: [validationMixin],

    validations: {
      confirmationCode:  {required,minLength:minLength(6),maxLength:maxLength(6)},
    },

    data: () => ({
      confirmationCode:'',
      submitted:false,
      serverError:'',
      isFormValid:false,
      isAddClassServerError:false,
      logo_image:process.env.VUE_APP_ROOT_ICONS_URL + 'Logo.png',
      disabledButton : false
    }),

    computed: {
      confirmationCodeErrors () {
        const errors = []
          this.serverError='';
          if (!this.$v.confirmationCode.$dirty) return errors
          !this.$v.confirmationCode.required && errors.push('OTP is required')
          !this.$v.confirmationCode.minLength && errors.push('Invalid OTP')
          !this.$v.confirmationCode.maxLength && errors.push('Invalid OTP')
          return errors
      },
      buttonErrorMessage(){
      if (this.$v.$invalid) {
          this.isFormValid = false;
        }else{
          this.isFormValid = true;
        }
      },
      isDataEmpty: function () {
        return isEmpty( this.$store.getters.getUserDetails);
      },
    },
    mounted () {
      if(this.isDataEmpty) {
        this.$router.push({ name: 'Login' });
        // this.email = this.$store.getters.getUserDetails.email;
      }

    },
    methods: {
      submit(e) {
        this.submitted = true;
        this.$v.$touch();
        if (this.$v.$invalid) {
          return;
        }
        this.$loading(true)
        // var axios = require('axios');
        // var data = JSON.stringify({"mobile_no":this.authUser.mobile_no,"aws_cognito_id":this.authUser.cognito_idp,"otp":this.confirmationCode, "name":this.authUser.user_name, "email":this.authUser.email, "type":'registration'});
        
        // var config = {
        //     method: 'post',
        //     url: process.env.VUE_APP_ROOT_API + 'verify-otp',
        //     headers: { 
        //       'Content-Type': 'application/json'
        //     },
        //     data : data
        // };
        // axios(config)
        this.$store.dispatch(VERIFY_MOBILE_OTP, {
          data:{
            mobile_no:this.$store.getters.getUserDetails.mobile_no,
            aws_cognito_id:atob(localStorage.getItem('cognito_idp')),
            otp:this.confirmationCode,
            name:this.$store.getters.getUserDetails.user_name,
            email:this.$store.getters.getUserDetails.email,
            type:'registration'
          },
          api:'verify-otp',
        })
        .then(() =>{
          this.isAddClassServerError = true;
          if(this.$store.getters.getVerifyMobileOtp.status == 'error'){ 
            this.$loading(false)
            this.serverError  = this.$store.getters.getVerifyMobileOtp.message; 
          }
          else{
            const signIn = Auth.signIn(this.$store.getters.getUserDetails.email, this.$store.getters.getUserDetails.password)
              .then(data => {
              this.$store.dispatch(USER_SIGNIN, {
                data: {
                  device_iemi_no: "1234567898765432",
                  aws_cognito_id: data.attributes["sub"],
                  firebase_token: data.attributes["sub"],
                  device_info: "desktop"
                },
                api: "login"
              })
              .then(() => {
                localStorage.setItem('cognito_idp',btoa(data.userSub))
                let response = this.$store.getters.getUserSignin.data;
                this.$loading(false);
                  JwtService.setToken(btoa(response.token));
                  localStorage.setItem("api_token",btoa(response.token));
                  var pathname = window.location.pathname;
                  if (pathname == '/ConfirmPasswordOtp') {
                    this.$router.push({ name: 'Changepassword' });
                  }
                  else{
                    this.$router.push({ name: 'congratulations' });
                  } 
              })
              .catch(err1 => {
                this.$loading(false)
              });

            }).catch(err => {
              this.$loading(false)
            });
          }
        })
        .catch((error) => {
          this.$loading(false)
        });
        
      },
      backtologin(evt){
        evt.preventDefault();
        this.$router.push({ name: 'Login' });
      },
      resendOtp(){
        this.disabledButton = true;
        this.myEnableFunction()
          // Re-enable after 2 seconds
        this.timeout = setTimeout(() => {
          this.disabledButton = false
        }, 1000)

      },
      myEnableFunction () {
        this.$loading(true);
        // var data   = JSON.stringify({"mobile_no":this.authUser.mobile_no,"aws_cognito_id":this.authUser.cognito_idp});
        //     var config = {
        //       method: 'post',
        //       url: process.env.VUE_APP_ROOT_API + 'send-otp',
        //       headers: { 
        //         'Content-Type': 'application/json'
        //       },
        //       data : data
        //     };
        //     axios(config)
        this.$store.dispatch(VERIFY_EMAIL_OTP, {
          data:{
            mobile_no:this.$store.getters.getUserDetails.mobile_no,
            aws_cognito_id:atob(localStorage.getItem('cognito_idp')),
          },
          api:'send-otp',
        })
        .then(()=> {
          this.$loading(false);
          if (this.$store.getters.getVerifyEmailOtp.data.status == 'error') {
              return [];
          }else{
            swal.fire({
            title: '',
            text: "OTP sent successfully",
            icon: 'success',
            showCancelButton: false,
            confirmButtonColor: '#051d42',
            //cancelButtonColor: '#d33',
            confirmButtonText: 'OK',
            //cancelButtonText:'No'
          }).then((result) => {
            this.$loading(false);
          })   
          }
        })
        .catch((error)=> {
          this.$loading(false);
        });
      },
      updateValue ($event,limitLength) {
        var keyCode = ($event.keyCode ? $event.keyCode : $event.which);
        if (limitLength.length > 5) {
           $event.preventDefault();
        }
      },
    beforeDestroy () {
    // clear the timeout before the component is destroyed
    clearTimeout(this.timeout)
    }
    },
  }
</script>